import React from "react";
import { ChevronRight, Plus, Crown, Users, Check } from "lucide-react";
import { ACADEMY_LOGO_H } from "../../data/assets";

const GOLD = "#D4AF37", RED = "#C41E24";
const PLAYERS = [
  { n: "Marcus", num: 10, tag: "Elite", gold: true, initials: "MR" },
  { n: "Sofia", num: 7, tag: "Technical Track sibling · $19", initials: "SR" },
  { n: "Diego", num: 4, tag: "Blueprint · included", initials: "DR" },
];

// Live, always-on-brand mock of the Hub's household Profile Switcher (replaces the old screenshot).
export const FamilySwitchMock = () => (
  <div data-testid="family-switch-image" className="relative w-full max-w-[300px] rounded-2xl border border-white/10 bg-[#0f0f0f] shadow-[0_30px_80px_rgba(0,0,0,0.6)] overflow-hidden text-left">
    <div className="flex items-center justify-between px-4 pt-4 pb-3 border-b border-white/10 bg-[#111]">
      <img src={ACADEMY_LOGO_H} alt="The Next O Technical Academy" className="h-7 w-auto object-contain" />
      <span className="inline-flex items-center gap-1 text-[9px] font-bold uppercase tracking-widest text-white/50"><Users size={10} /> Household</span>
    </div>
    <div className="px-3 pt-3 pb-1 font-mono text-[9px] uppercase tracking-[0.3em] text-white/40">Switch player</div>
    <ul className="px-3 pb-2 space-y-2">
      {PLAYERS.map((p, i) => (
        <li key={p.n} className="flex items-center gap-3 rounded-xl border px-3 py-2.5" style={{ borderColor: p.gold ? `${GOLD}66` : "rgba(255,255,255,0.08)", background: p.gold ? `linear-gradient(120deg, ${GOLD}1a, rgba(20,20,20,0.9))` : "rgba(255,255,255,0.03)" }}>
          <span className="w-9 h-9 rounded-full flex items-center justify-center font-cover text-sm shrink-0" style={{ background: p.gold ? `linear-gradient(135deg, #F0D77A, ${GOLD})` : RED, color: p.gold ? "#111" : "#fff" }}>{p.initials}</span>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2"><span className="font-headings uppercase tracking-wide text-sm">{p.n}</span><span className="font-mono text-[10px] text-white/40">#{p.num}</span>{i === 0 && <Check size={12} style={{ color: GOLD }} />}</div>
            <div className="text-[10px] mt-0.5 flex items-center gap-1 truncate" style={{ color: p.gold ? GOLD : "rgba(255,255,255,0.5)" }}>{p.gold && <Crown size={10} />}{p.tag}</div>
          </div>
          <ChevronRight size={14} className="text-white/30 shrink-0" />
        </li>
      ))}
    </ul>
    <div className="px-3 pb-4">
      <button type="button" tabIndex={-1} className="w-full inline-flex items-center justify-center gap-2 text-[11px] font-bold uppercase tracking-wider py-2.5 rounded-lg text-white" style={{ background: RED }}><Plus size={13} /> Add a player</button>
      <div className="text-center font-mono text-[9px] uppercase tracking-[0.25em] mt-2" style={{ color: GOLD }}>Sibling discount applied</div>
    </div>
  </div>
);
